import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WebStoryDetailComponent } from './web-story-detail.component';
import { WebStoriesLoadingComponent } from './webstories/web-stories-loading.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const routes: Routes = [
	{
		path: ':id/amp',
		component: WebStoryDetailComponent,
	},
	{
		path: '',
		component: WebStoriesLoadingComponent,
	},
];

@NgModule({
	declarations: [WebStoryDetailComponent, WebStoriesLoadingComponent],
	imports: [RouterModule.forChild(routes), CommonModule, MatProgressSpinnerModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WebStoryDetailModule {}
